import { ConciergeCatalogRoute } from '@/lib/pages/concierge/ConciergeCatalogRoute';
import { getConciergeCatalogServerSideProps } from '@/lib/pages/concierge/get-static-props';

import { getConciergeShowsCatalogPage } from '@/lib/entities/concierge/server-content';

import { InferGetServerSidePropsType } from 'next';

const PATH = '/concierge/shows';

export default function ConciergeShowsPage({
  page,
  locale,
  pageSeo,
  listingRobots,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <ConciergeCatalogRoute
      page={page}
      locale={locale}
      pageSeo={pageSeo}
      listingRobots={listingRobots}
      path={PATH}
      keywords="shows entertainment phuket concierge"
      itemCatalog="shows"
    />
  );
}

export const getServerSideProps = getConciergeCatalogServerSideProps(
  getConciergeShowsCatalogPage,
  PATH
);
